"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractDeliverableOverride = void 0;
var ContractDeliverableOverride;
(function (ContractDeliverableOverride) {
    let contractingMethod;
    (function (contractingMethod) {
        contractingMethod["SELF_SERVE"] = "self-serve";
        contractingMethod["DIRECT"] = "direct";
        contractingMethod["COMPANY"] = "company";
        contractingMethod["AGENCY"] = "agency";
        contractingMethod["CUSTOM"] = "custom";
    })(contractingMethod = ContractDeliverableOverride.contractingMethod || (ContractDeliverableOverride.contractingMethod = {}));
    let contractingTarget;
    (function (contractingTarget) {
        contractingTarget["DIRECT"] = "direct";
        contractingTarget["AGENCY"] = "agency";
    })(contractingTarget = ContractDeliverableOverride.contractingTarget || (ContractDeliverableOverride.contractingTarget = {}));
})(ContractDeliverableOverride = exports.ContractDeliverableOverride || (exports.ContractDeliverableOverride = {}));
